<div class="container mt-3 text-center">
  <osre-language-switcher class=""></osre-language-switcher>

  <h3 class="mt-5" translate>Invitation or page not found.</h3>
  <a [routerLink]="['authentication']" class="" translate>Login page</a>
</div>

